import { buildBusinessErrorFromError, TeleserviceTranslationSchema, BusinessError, ErrorKind, EntityKind, } from '@mgdis/eu-domain';
import _get from 'lodash/get';
import _merge from 'lodash/merge';
class I18nAdapter {
    tenantId;
    lang = 'fr-FR';
    translationsJson;
    restHttpAdapter;
    /**
     * I18n translations adapter.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.translationsJson = {};
        this.restHttpAdapter = restHttpAdapter;
    }
    getTagLang() {
        return this.lang.split('-')[0] ?? 'fr';
    }
    /**
     * Return the coresponding translation for a given key
     * can accept props as options
     *
     * @param key - the path of the translation
     * @param options - props to map in the translation
     * @returns the translation filled with is options
     */
    translate(key, options) {
        let trad = (_get(this.translationsJson, key, key) ?? '');
        if (options && trad) {
            for (const key of Object.keys(options)) {
                trad = trad.replaceAll(`{{${key}}}`, options[key]);
            }
        }
        return trad;
    }
    /**
     * Get i18n from tenant
     */
    async getI18nFromTenant() {
        try {
            if (!this.tenantId)
                throw new Error('tenant is required');
            const lang = this.getTagLang();
            const res = await this.restHttpAdapter.get(`/aides/admin/tenants/${this.tenantId}/publicI18N/${lang}?merge=true`, undefined, true);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    /**
     * Get i18n from ref-ressources by given module
     */
    async getI18nFromRessourceModule(module) {
        try {
            if (!this.tenantId)
                throw new Error('tenant is required');
            const lang = this.getTagLang();
            const res = await this.restHttpAdapter.get(`/referentiel-ressources/services/portail-depot-demande-aides/tenants/${this.tenantId}/resources/${module}-${lang}?merge=true`, undefined, true);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    /**
     *  Merge given i18n into current one
     */
    mergeTranslations(translationsToMerge) {
        this.translationsJson = _merge(this.translationsJson, translationsToMerge);
    }
    getTranslationJson() {
        return this.translationsJson;
    }
    /**
     * Get translations specific to a teleservice
     *
     * @param typeTeleservice - teleservice type
     * @param teleserviceReference - teleservice reference
     * @returns teleservice translations
     */
    async getTeleserviceTranslationJson(typeTeleservice, teleserviceReference) {
        const locale = this.getTagLang();
        const module = `/referentiel-ressources/services/portail-depot-demande-aides/tenants/${this.tenantId}/resources/teleservice-${typeTeleservice}-default-${locale}/extensions/teleservice-${typeTeleservice}-${teleserviceReference}-${locale}?merge=true`;
        try {
            const res = await this.restHttpAdapter.get(module, undefined, true);
            const result = await TeleserviceTranslationSchema.safeParseAsync(res.data);
            if (!result.success) {
                return {
                    error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                        entity: EntityKind.NO_BUSINESS_ENTITY,
                        message: `[I18nAdapter] getTeleservice - Error parsing. ${result.error.message}`,
                    }),
                };
            }
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { I18nAdapter };
//# sourceMappingURL=i18n.adapter.js.map